export function compareStrings(a?:string,b?:string) :number  {
  return (a??"").localeCompare(b??"")
}
